import React, { useState, useRef } from "react";
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import { Divider, Button } from "@mui/material";
import Paper from '@mui/material/Paper';
import Modal from "react-bootstrap/Modal";
import CountrySelect from '../CountrySelect';
import { margin, width } from "@mui/system";
import { getCenters } from "../actions/center";
import { getAgencies } from "../actions/agency";
import { getUsers } from "../actions/user";
import UserModalForm from "../components/Users/UserModalForm"
import { useEffect } from "react";
import md5 from "md5";
import { toast } from "react-toastify";
import { putUser } from "../actions/user";
import { updateCurrentUser } from "../actions/auth"

const Profile = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    if (!listCenters) dispatch(getCenters());
    if (!listAgencies) dispatch(getAgencies());
    if (!listUsers) dispatch(getUsers());
  }, []);

  const { centers: listUsers } = useSelector((state) => state.users);
  const { centers: listCenters } = useSelector((state) => state.centers);
  const { agencies: listAgencies } = useSelector((state) => state.agencies);
  const { user: currentUser } = useSelector((state) => state.auth);

  const [email, setEmail] = useState(currentUser ? currentUser.email : "");
  const [firstname, setFirstName] = useState(currentUser ? currentUser.firstName : "");
  const [lastname, setLastName] = useState(currentUser ? currentUser.lastName : "");
  const [address_one, setAddressOne] = useState(currentUser ? currentUser.adress : "");
  const [address_two, setAddressTwo] = useState(currentUser ? currentUser.adress2 : "");
  const [zip_code, setZipCode] = useState(currentUser ? currentUser.zipcode : "");
  const [phonenumber, setPhoneNumber] = useState(currentUser ? currentUser.phoneNumber : "");
  const [locality, setLocality] = useState(currentUser ? currentUser.locality : "");
  const [country, setCountry] = useState(currentUser ? currentUser.country : "");
  const [type, setType] = useState(currentUser ? currentUser.type : "");
  const [active, setActive] = useState(currentUser ? currentUser.active : "");
  const [id_center, set_id_center] = useState(currentUser ? currentUser.idCenter : "");
  const [id_agency, set_id_agency] = useState(currentUser ? currentUser.idAgency : "");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  if (!currentUser) {
    return <Navigate to="/" />;
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    let user_tmp = {};

    user_tmp.id = currentUser.id
    user_tmp.password = password;
    user_tmp.lastName = lastname;
    user_tmp.firstName = firstname;
    user_tmp.active = active;
    user_tmp.adress = address_one;
    user_tmp.adress2 = address_two;
    user_tmp.country = country;
    user_tmp.email = email;
    user_tmp.locality = locality;
    user_tmp.phoneNumber = phonenumber;
    user_tmp.zipcode = zip_code;
    user_tmp.type = type;
    user_tmp.idAgency = id_agency;
    user_tmp.idCenter = id_center;
    user_tmp.agencyName = id_agency > 0 ? listAgencies.filter((a) => a.id == id_agency)[0].name : null
    user_tmp.centerName = id_center > 0 ? listCenters.filter((c) => c.id == id_center)[0].name : null

    if (password == "") {
      user_tmp.password = currentUser.password;
    } else {
      user_tmp.password = md5(password);
    }

    dispatch(putUser(user_tmp))
      .then(() => {
        toast.success(`Profile upated successfuly`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER });
        dispatch(updateCurrentUser(user_tmp))
      })
      .catch((error) => {
        toast.error(
          `An Error occured while ${user_tmp.id > 0 ? "updating" : "creating"} the user. Try again later.`,
          { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
      });
  }

  return (

    <div className="app-container">
      <Grid container>
        <Grid xs={12}>
          <UserModalForm
            isModal={false}
            setActive={setActive} active={active}
            setFirstName={setFirstName} firstname={firstname}
            setLastName={setLastName} lastname={lastname}
            setType={setType} type={type}
            set_id_agency={set_id_agency} id_agency={id_agency}
            set_id_center={set_id_center} id_center={id_center}
            setAddressOne={setAddressOne} address_one={address_one}
            setAddressTwo={setAddressTwo} address_two={address_two}
            setZipCode={setZipCode} zipcode={zip_code}
            setLocality={setLocality} locality={locality}
            setCountry={setCountry} country={country}
            setEmail={setEmail} email={email}
            setPhoneNumber={setPhoneNumber} phonenumber={phonenumber}
            setPassword={setPassword} password={password}
            setPassword2={setPassword2} password2={password2}
            handleSubmit={handleSubmit}
            listAgencies={listAgencies}
            listCenters={listCenters}
            currentUser={currentUser} />
        </Grid>
      </Grid>
    </div>
  );
};

export default Profile;